import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 获取消息列表
 * @param {Object} params - 查询参数
 * @param {string} params.type - 消息类型：all/system/account/transaction/announcement
 * @param {string} params.is_read - 阅读状态：all/0/1
 * @param {number} params.page - 页码（可选，只有传入page_size时才有效）
 * @param {number} params.page_size - 每页数量（可选，不传则返回所有数据）
 * @param {string} params.title - 搜索标题（模糊搜索）
 * @returns {Promise}
 */
export const get_messages_list = (params = {}) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.MESSAGES_LIST}`, params);
};
